// Bots. A bot record carries its own `config` (Bot Configuration) and `appearance`
// (Appearance & Branding), so every module edits the same bot by id.
import { apiClient } from "../apiClient";

const send = (url, method, body) => apiClient(url, { method, body: body === undefined ? undefined : JSON.stringify(body) }).then((res) => res.data);

export const listBots = () => apiClient("/api/bots").then((res) => res.data);
/** -> { items, meta: { total, plan, botLimit } } — meta powers the plan-usage meter. */
export const listBotsWithMeta = () => apiClient("/api/bots").then((res) => ({ items: res.data, meta: res.meta }));
export const getBot = (id) => apiClient(`/api/bots/${id}`).then((res) => res.data);
export const createBot = (payload) => send("/api/bots", "POST", payload);
export const updateBot = (id, patch) => send(`/api/bots/${id}`, "PATCH", patch);
export const deleteBot = (id) => send(`/api/bots/${id}`, "DELETE");
export const setBotStatus = (id, status) => updateBot(id, { status });
export const testBotMessage = (id, message) => send(`/api/bots/${id}/test-message`, "POST", { message });
